export default "__VITE_ASSET__8GTA5Rp___"